import featureDetection from './features'

export default {
  install(Vue: any) {
    Vue.prototype.$deviceInfo = featureDetection
  },
}
